import { render, staticRenderFns } from "./TripFlagIcon.vue?vue&type=template&id=5a33be24&scoped=true"
import script from "./TripFlagIcon.vue?vue&type=script&lang=js"
export * from "./TripFlagIcon.vue?vue&type=script&lang=js"
import style0 from "./TripFlagIcon.vue?vue&type=style&index=0&id=5a33be24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a33be24",
  null
  
)

export default component.exports